import { axiosAjax } from '@app/src/config/axios';
import { JobModel } from '@app/src/views/StepOne/form/models/job';
import { isClientEnv } from '@app/src/utils/validations';

export const jobService = {
  async get(jobName: string): Promise<JobModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_JOB.replace(':jobName', jobName), config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
}